<script>
import { mapActions, mapGetters } from 'vuex';
import ListItem from './components/ListItem';
import DetailDialog from './components/DetailDialog';
import snackbarMixin from '@/mixins/snackbar';

export default {
  name: 'Prisoner',
  components: {
    ListItem,
    DetailDialog,
  },
  mixins: [snackbarMixin],
  data() {
    return {
      hasError: false,
      isInitialized: false,
      isLoading: false,
      isSaving: false,
      itemList: [],
      saveDialogData: {
        item: {},
        visible: false,
        isCreateMode: false,
      },
      sortBy: 'Id',
      descending: true,
      search: '',
    };
  },
  computed: {
    ...mapGetters('satinAlmaOdemeTalep', ['listHeaders']),
  },
  mounted() {
    this.initializeData();
  },
  methods: {
    ...mapActions('satinAlmaOdemeTalep',['getList', 'reject', 'approve']),
    ...mapActions('app', ['showOverlay', 'hideOverlay']),
    fetchData() {
      this.isLoading = true;
      this.getList()
        .then((data) => {
          this.itemList = data.data;
          this.isInitialized = true;
        })
        .catch(() => {
          this.hasError = true;
        })
        .finally(() => {
          this.isLoading = false;
        });
    },
    initializeData() {
      this.isLoading = true;
      Promise.all([this.getList()])
        .then(([prisonerResult]) => {
          this.itemList = prisonerResult.data;
          this.isInitialized = true;
          this.isLoading = false;
        }, () => {
          this.hasError = true;
          this.isLoading = false;
        });
    },
    rejectRecord(id){
      this.isLoading = true;
      this.showOverlay();
      this.reject(id)
        .then(() => {
          this.showSuccessMessage(`${id} numaları bekleyen ödeme talebi reddedilmiştir.`);
          this.fetchData();
        })
        .catch((err) => {
          this.showErrorMessage(err.response && err.response.data);
        })
        .finally(() => {
          this.isDeleting = false;
          this.hideOverlay();
        });
    },
    approveRecord(id) {
      this.isDeleting = true;
      this.showOverlay();
      this.approve(id)
        .then(() => {
          this.showSuccessMessage(`${id} numaralı ödeme talebi onaylanmıştır.`);
          this.fetchData();
        })
        .catch((err) => {
          this.showErrorMessage(err.response && err.response.data);
        })
        .finally(() => {
          this.isDeleting = false;
          this.hideOverlay();
        });
    },
    openPurchaseDetailDialog(data) {
      this.saveDialogData.item = data;
      this.saveDialogData.visible = true;
    },
    closeSaveDialog() {
      this.saveDialogData.visible = false;
    },
    customFilter(value, search, item) {
      // eslint-disable-next-line eqeqeq
      if (!search || search == '') {
        return true;
      }

      const searchStr = search.toString().toLowerCase().trim();

      return !!(
        // eslint-disable-next-line eqeqeq
        item.Id == searchStr
        || item.pfaaliyet.toString().toLowerCase().trim().includes(searchStr)
        || item.proje.toString().toLowerCase().trim().includes(searchStr)
        || item.tur.toString().toLowerCase().trim().includes(searchStr)
        || item.tedarikci.toString().toLowerCase().trim().includes(searchStr)
        || item.konu.toString().toLowerCase().trim().includes(searchStr)
        || item.tutar.toString().toLowerCase().trim().includes(searchStr)
      );
    },
  },
};
</script>

<template>
  <div>
    <template v-if="hasError">
      <p class="js-error-template ma-3">
        Satın Alma Ödeme Talepleri listesinde bir hata oluştu. Lütfen tekrar deneyin!
      </p>
    </template>

    <template v-else>
      <v-toolbar dark dense color="#9FA8A3">
        <b> Satın Alma Ödeme Talepleri </b>
        <v-spacer />
      </v-toolbar>

      <v-card>
        <v-card-title>
          <v-spacer />
          <v-text-field
            v-model="search"
            append-icon="search"
            label="Search"
            single-line
            hide-details
          />
        </v-card-title>
        <v-data-table
          :headers="listHeaders"
          :items="itemList"
          :sort-by.sync="sortBy"
          :sort-desc.sync="descending"
          :search="search"
          :custom-filter="customFilter"
          class="elevation-1 spec-table"
          item-key="Id"
        >
          <template slot="item" slot-scope="props">
            <list-item
              :loading="isLoading"
              :item="props.item"
              @details="openPurchaseDetailDialog(props.item, false)"
              @rejectRecord="rejectRecord(props.item.pfaaliyet)"
              @approveRecord="approveRecord(props.item.pfaaliyet)"
            />
          </template>
        </v-data-table>
      </v-card>
    </template>

    <detail-dialog
      v-if="saveDialogData.visible"
      @refresh="fetchData"
      @close="closeSaveDialog"
      :item="saveDialogData.item"
      :is-create-mode="saveDialogData.isCreateMode"
    />
  </div>
</template>
